/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type PipeTransform, Pipe } from '@angular/core';
import { I18nService, UNPLACEHOLDER } from '@dm/core';

@Pipe({ name: 'keyAlgorithm' })
export class KeyAlgorithmPipe implements PipeTransform {
    constructor(private i18nService: I18nService) {}
    transform(value: string | number): string {
        switch (Number(value)) {
            case 0:
                return this.i18nService.get('common.EnumDefine_KEY_ALGORITHM_RSA');
            case 1:
                return this.i18nService.get('common.EnumDefine_KEY_ALGORITHM_ECC');
            case 2:
                return this.i18nService.get('common.EnumDefine_KEY_ALGORITHM_DSA');
            case 3:
                return this.i18nService.get('common.EnumDefine_KEY_ALGORITHM_SM2');
            default:
                return UNPLACEHOLDER;
        }
    }
}
